import React, { Component } from 'react';
import { Grid, Typography, withStyles } from '@material-ui/core';
import ItemFotoMorte from './itemFotoMorte';
import { idsFarois } from '../../../../constants/idsFarois';
export class AlbumFotoMortePage extends Component {
  obterQuantidadeEventosNoPasto = (quantidade, tipoColeta) => {
    const singular = tipoColeta === 'NASCIMENTO' ? 'Nascimento' : 'Morte';
    const plural = tipoColeta === 'NASCIMENTO' ? 'Nascimentos' : 'Mortes';
    return quantidade === 1 ? `${quantidade} ${singular}` : `${quantidade} ${plural}`;
  };

  render() {
    const { farois, pastoSelecionado, classes, farolSelecionado } = this.props;
    const tipoColeta = farolSelecionado === idsFarois.nascimentos ? 'NASCIMENTO' : 'MORTE';
    const farolSelecionadoData = farois.find(farol => farol.IdFarol === farolSelecionado);
    const eventoPastoSelecionado = farolSelecionadoData?.Pasto?.find(
      pasto => pasto.IdPasto === pastoSelecionado.IdPasto
    );
    if (!eventoPastoSelecionado?.Valor?.Coletas) return null;

    return (
      <Grid container>
        <Grid item xs={12}>
          <Typography
            variant="subtitle1"
            align="left"
            style={{ marginLeft: '3.5%', fontWeight: 'bold', marginTop: '20px' }}
            id="tituloQuantidadeAnimais"
          >
            {this.obterQuantidadeEventosNoPasto(
              eventoPastoSelecionado.Valor.Quantidade,
              tipoColeta
            )}
          </Typography>
        </Grid>

        {eventoPastoSelecionado.Valor.Coletas.map((coleta, index) => (
          <Grid
            key={coleta.IdColetaFoto || `${coleta.DataColeta}-${index}`}
            item
            xs={6}
            className={classes.containerItemFoto}
          >
            <ItemFotoMorte
              id="itemFotoMorte"
              nomePasto={pastoSelecionado.Nome}
              categoria={coleta.Categoria}
              coleta={coleta}
              coletasPastoSelecionado={this.adicionaRefColetasPastoSelecionado(
                eventoPastoSelecionado.Valor.Coletas
              )}
              idColetaFoto={coleta.IdColetaFoto}
              listaIdFotosPasto={this.getListaIdFotosPasto(
                eventoPastoSelecionado,
                tipoColeta
              )}
              {...(tipoColeta === 'NASCIMENTO' && { tipoColeta })}
            />
          </Grid>
        ))}

      </Grid>
    );
  }

  adicionaRefColetasPastoSelecionado(coletasPastoSelecionado) {
    const teste = coletasPastoSelecionado;
    teste.forEach(coleta => {
      coleta.ref = React.createRef();
    });
    return teste;
  }

  getListaIdFotosPasto(eventoPastoSelecionado, tipoColeta) {
    const idsFotos = eventoPastoSelecionado.Valor.Coletas.map(coleta => coleta.IdColetaFoto);
    return tipoColeta === 'NASCIMENTO' ? idsFotos.filter(Boolean) : idsFotos;
  }
}

const styles = {
  containerItemFoto: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: '24px'
  }
}

export default withStyles(styles)(AlbumFotoMortePage);
